import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const rolePermissionEditApi = createAsyncThunk(
    'auth/rolePermissions/edit',
    async (data, { rejectWithValue }) => {
        try {
            const { ID, ...rest } = data
            const response = await AuthAxios.patch(apiRoutes.adminAction(`roles_permissions/roles/${ID}`, 1), rest)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const rolePermissionEditSlice = createSlice({
    name: 'rolePermission Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(rolePermissionEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(rolePermissionEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(rolePermissionEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const rolePermissionEditReducer = rolePermissionEditSlice.reducer